import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@quovy/ui";
import { Input } from "@quovy/ui/input";
import type { IngressProfile } from "@quovy/control-plane-contract";

const INGRESS_PROFILE_LABEL: Record<IngressProfile, string> = {
  azure_keyvault: "Azure Key Vault + AKS application routing",
  azure_gateway: "Azure Gateway API / Application Gateway",
  aws_alb: "AWS ALB + ACM",
  cert_manager: "cert-manager (rehearsal only)",
};

export function defaultIngressProfile(cloud: string): IngressProfile {
  return cloud === "azure" ? "azure_keyvault" : "aws_alb";
}

function certificatePlaceholder(profile: IngressProfile): string {
  if (profile === "aws_alb") {
    return "arn:aws:acm:us-east-1:123456789012:certificate/…";
  }
  if (profile === "cert_manager") return "letsencrypt-prod";
  return "https://<vault>.vault.azure.net/certificates/<name>";
}

export function IngressProfileFields({
  idPrefix,
  cloud,
  profile,
  certificate,
  onProfileChange,
  onCertificateChange,
}: {
  idPrefix: string;
  cloud: string;
  profile: IngressProfile;
  certificate: string;
  onProfileChange: (profile: IngressProfile) => void;
  onCertificateChange: (certificate: string) => void;
}) {
  return (
    <>
      <div className="grid gap-2">
        <label htmlFor={`${idPrefix}-ingress-profile`} className="text-sm font-medium">
          Ingress profile
        </label>
        <Select value={profile} onValueChange={(next: IngressProfile) => onProfileChange(next)}>
          <SelectTrigger id={`${idPrefix}-ingress-profile`} className="w-full">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {cloud === "azure" ? (
              <>
                <SelectItem value="azure_keyvault">
                  {INGRESS_PROFILE_LABEL.azure_keyvault}
                </SelectItem>
                <SelectItem value="azure_gateway">{INGRESS_PROFILE_LABEL.azure_gateway}</SelectItem>
              </>
            ) : (
              <SelectItem value="aws_alb">{INGRESS_PROFILE_LABEL.aws_alb}</SelectItem>
            )}
            <SelectItem value="cert_manager">{INGRESS_PROFILE_LABEL.cert_manager}</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="grid gap-2">
        <label htmlFor={`${idPrefix}-certificate`} className="text-sm font-medium">
          Certificate reference
        </label>
        <Input
          id={`${idPrefix}-certificate`}
          value={certificate}
          placeholder={certificatePlaceholder(profile)}
          autoComplete="off"
          onChange={(event) => onCertificateChange(event.target.value.trim())}
        />
      </div>
    </>
  );
}
